import { getPosthogClient } from "./posthog";
import {
  FeatureFlag,
  FeatureFlagsRecord,
} from "./posthogFeatureFlags.contracts";

const DEV_OVERRIDES: Partial<FeatureFlagsRecord> = {};

export const isFeatureFlagEnabled = (flag: FeatureFlag) => {
  const client = getPosthogClient();
  const isEnabled = client?.isFeatureEnabled?.(flag);
  if (
    process.env.ENVIRONMENT === "development" ||
    process.env.ENVIRONMENT === "test"
  ) {
    return DEV_OVERRIDES?.[flag] !== undefined
      ? (DEV_OVERRIDES[flag] as boolean)
      : Boolean(isEnabled);
  }
  return Boolean(isEnabled);
};

export const getFeatureFlagPayload = <T extends FeatureFlag>(
  flag: T
): FeatureFlagsRecord[T] => {
  const client = getPosthogClient();
  const raw = client?.getFeatureFlagPayload(flag) as unknown;

  // AIDEV-NOTE: PostHog returns stringified JSON for payloads via /decide; parse if needed
  const payload = ((): FeatureFlagsRecord[T] => {
    if (typeof raw === "string") {
      try {
        return JSON.parse(raw) as FeatureFlagsRecord[T];
      } catch {
        // fall through to raw if parsing fails
      }
    }
    return raw as FeatureFlagsRecord[T];
  })();

  if (
    process.env.ENVIRONMENT === "development" ||
    process.env.ENVIRONMENT === "test"
  ) {
    // AIDEV-NOTE: DEV_OVERRIDES applies primarily to boolean flags; for payload flags fallback to parsed payload
    return DEV_OVERRIDES?.[flag] !== undefined ? DEV_OVERRIDES[flag] : payload;
  }
  return payload;
};
